<script setup>
import Button from "@/Components/Button.vue";
import { ref, onMounted, watch } from "vue";

const props = defineProps({
  show: Boolean,
});

const emit = defineEmits(["close"]);

const show = ref(props.show);
</script>

<template>
  <div class="w-full h-full fixed left-0 top-0 z-10" v-if="props.show">
    <div
      @click="emit('close')"
      class="w-full h-full bg-black opacity-50 top-0 absolute z-10"
    ></div>
    <div
      class="
        z-40
        sm:w-[600px] sm:min-w-[30vw]
        min-w-[80vw] min-h-[35vh]
        flex flex-col
        items-center
        gap-2
        -translate-y-1/2
        p-6
        py-10
        bg-white
        rounded-2xl
        shadow-2xl
        top-1/2
        left-1/2
        -translate-x-1/2
        absolute
      "
    >
      <i
        class="las la-times absolute top-6 right-6 cursor-pointer"
        @click="emit('close')"
      ></i>
      <i class="las la-exclamation-circle text-oteo-300 text-7xl"></i>
      <span class="text-2xl font-medium"><slot name="title" /></span>
      <p class="text-lg text-center">
        <slot name="message" />
      </p>
      <div class="mt-8">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>
